module.exports = __webpack_public_path__ + "img/技能训练.cc403fd4.svg";